var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-popconfirm',{attrs:{"title":"Bạn có chắc muốn xóa thông báo?","ok-text":"Ok","cancel-text":"Hủy"},on:{"confirm":_vm.onConfirm}},[_c('a',{attrs:{"href":"#"}},[_vm._v("Xóa")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }